// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAjA8yz4qt-W62iytVPKP5NBdWD8CmwyoI",
  authDomain: "visionbird-web.firebaseapp.com",
  projectId: "visionbird-web",
  storageBucket: "visionbird-web.firebasestorage.app",
  messagingSenderId: "908353965673",
  appId: "1:908353965673:web:1bdfff24ef4db4c763dcf8",
  measurementId: "G-SQYEX40HYR",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Firestore
export const db = getFirestore(app);

// Auth
export const auth = getAuth(app);